<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <h1 class="text-center mt-3">Privileges Category</h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">
      <div class="row">
        <div class="col">
          <label for="nameTh">Name (TH)</label>
          <input
            id="nameTh"
            v-model="nameTh"
            type="text"
            class="form-control"
            :class="{
              'input--error': isSubmit && error.errorNameTh,
            }"
          />
          <div v-if="isSubmit && error.errorNameTh" class="text-error">
            {{ error.errorNameTh.message }}
          </div>
        </div>
        <div class="col">
          <label for="nameEn">Name (EN)</label>
          <input
            id="nameEn"
            v-model="nameEn"
            type="text"
            class="form-control"
            :class="{
              'input--error': isSubmit && error.errorNameEn,
            }"
          />
          <div v-if="isSubmit && error.errorNameEn" class="text-error">
            {{ error.errorNameEn.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <BrandDropdown
            v-model="brandSelected"
            @setBrand="setBrand"
            @setBrands="setBrands"
          ></BrandDropdown>
          <div v-if="isSubmit && error.errorBrand" class="text-error">
            {{ error.errorBrand.message }}
          </div>
        </div>
        <div class="col">
          <div>Status</div>
          <input
            class="form-check-input mr-2"
            type="checkbox"
            id="checkActive"
            v-model="isActive"
          />
          <label class="form-check-label" for="checkActive"> Active </label>
        </div>
      </div>
      <div class="row">
        <div class="col-6 pt-0">
          <label for="uploadIconImage">Icon</label>
          <input
            id="uploadIconImage"
            type="file"
            @change="uploadIconImage"
            ref="uploadIconImage"
            class="form-control mt-3"
            :class="{
              'input--error': isSubmit && error.errorImg,
            }"
          />
          <div v-if="isSubmit && error.errorImg" class="text-error">
            {{ error.errorImg.message }}
          </div>
        </div>
        <div id="col-6">
          <img
              v-if="previewImg"
              :src="previewImg"
              alt="previewImg"
              style="max-width: 100%; height: auto; object-fit: contain;"
          />
          <button
            v-if="previewImg"
            class="btn btn-outline-danger btn-del mt-3"
            @click="deleteIconImage()"
          >
            Delete
          </button>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-5">
        <button
          class="btn btn-outline-danger btn-cancel"
          @click="() => $router.push({ name: 'PrivilegeCategory' })"
        >
          Cancel
        </button>
        <button class="btn btn-outline-success ml-10" @click="checkValidate">
          Save
        </button>
      </div>
      <v-dialog v-model="showDialog" width="500" persistent>
        <div class="content-dialog">
          <h3>{{ message }}</h3>
          <div class="row text-center">
            <div v-if="showSuccess && id" class="col-12">
              <button class="btn-back" @click="getDetail()">ตกลง</button>
            </div>
            <div v-if="showSuccess" class="col-12">
              <button
                class="btn-back"
                @click="() => $router.push({ name: 'PrivilegeCategory' })"
              >
                กลับสู่หน้าหลัก
              </button>
            </div>
          </div>
          <div v-if="!showSuccess" class="row text-center">
            <div class="col">
              <button class="btn-back" @click="showDialog = false">ปิด</button>
            </div>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import PrivilegeService from "services/api/privilegeCategory.service.js";
import PresignedUploadUrlService from "services/api/presignedUploadUrl.service";
import BrandDropdown from "components/Brand/BrandDropdown";
export default {
  components: {
    BrandDropdown,
  },
  data() {
    return {
      brandSelected: null,
      isLoading: false,
      nameTh: "",
      nameEn: "",
      imgFile: null,
      previewImg: null,
      isActive: false,
      id: this.$route.query.id,
      showDialog: false,
      message: null,
      showSuccess: false,
      error: {
        errorNameTh: null,
        errorNameEn: null,
        errorBrand: null,
        errorImg: null,
      },
      isSubmit: false,
    };
  },
  mounted() {
    if (this.id) {
      this.getDetail();
    }
  },
  methods: {
    async getDetail() {
      this.isLoading = true;
      this.setDefault();
      await PrivilegeService.getDetailPrivilegeCategory(this.id)
        .then((res) => {
          const data = res.data.privilegeCategory;
          this.isLoading = false;
          this.nameEn = data.nameEn;
          this.nameTh = data.nameTh;
          this.isActive = data.status === "ACTIVE";
          this.imgFile = data.icon;
          this.previewImg = data.iconUrl;
          this.setBrand(data.brandCode);
        })
        .catch((err) => {
          console.log("Error: ", err.response);
          this.isLoading = false;
          alert("เกิดข้อผิดพลาด");
          this.$router.push({ name: "PrivilegeCategory" });
        });
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
    },
    setBrands(brands) {
      const listBrands = brands;
      listBrands.forEach((brand) => {
        if (brand.id === this.brandSelected) {
          this.brandSelected = brand;
        }
      });
    },
    setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
    },
    checkValidate() {
      this.isSubmit = true;
      this.isLoading = true;
      const body = {
        brandCode: this.brandSelected.id,
        nameTh: this.nameTh,
        nameEn: this.nameEn,
        status: this.isActive ? "ACTIVE" : "INACTIVE",
        icon: this.imgFile,
      };
      if (this.id) {
        this.updatePrivilegeCategory(body);
      } else {
        this.addPrivilegeCategory(body);
      }
    },
    async addPrivilegeCategory(body) {
      await PrivilegeService.createPrivilegeCategory(body)
        .then((res) => {
          const data = res.data;
          this.isLoading = false;
          if (data.status === "failure") {
            this.setErrorText(data.errors);
          } else {
            this.showDialog = true;
            this.showSuccess = true;
            this.message = data.message;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error: ", err.response);
        });
    },
    async updatePrivilegeCategory(body) {
      await PrivilegeService.updatePrivilegeCategory(body, this.id)
        .then((res) => {
          const data = res.data;
          this.isLoading = false;
          if (data.status === "failure") {
            this.setErrorText(data.errors);
          } else {
            this.showDialog = true;
            this.showSuccess = true;
            this.message = data.message;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error: ", err.response);
        });
    },
    setErrorText(errors) {
      this.error.errorNameTh = errors.find((e) => e.fieldName === "nameTh");
      this.error.errorNameEn = errors.find((e) => e.fieldName === "nameEn");
      this.error.errorBrand = errors.find((e) => e.fieldName === "brandCode");
      this.error.errorImg = errors.find((e) => e.fieldName === "icon");
    },
    uploadIconImage(e) {
      if (e.target.files) {
        const file = e.target.files[0];
        this.previewImg = URL.createObjectURL(file);
        this.getPresignURL(file);
      }
    },
    async getPresignURL(file) {
      this.isLoading = true;
      await PresignedUploadUrlService.getS3SignUrl("privilege", file)
        .then((res) => {
          const data = res.data;
          this.imgFile = data.key;
          this.updatePhotoToS3(data.presignedUrl, file);
        })
        .catch((err) => {
          console.log("Error: ", err.response);
        });
    },
    async updatePhotoToS3(url, file) {
      await PresignedUploadUrlService.pushProfilePhotoToS3(url, file);
      this.isLoading = false;
    },
    deleteIconImage() {
      this.imgFile = null;
      this.previewImg = null;
      this.$refs.uploadIconImage.value = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-dialog {
  height: 330px;
  background: #fff;
  overflow: hidden;
}
</style>
